import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'unh-banner-pro',
  templateUrl: './banner-pro.component.html',
  styleUrls: ['./banner-pro.component.scss']
})
export class BannerProComponent implements OnInit {

  constructor(
    private router: Router
  ) { }

  ngOnInit(): void {
  }
  navigateTo(){
    this.router.navigate(['/assinatura/planos-e-precos']);
  }
}
